import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab7',
  templateUrl: './awsop-lab7.component.html',
  styleUrls: ['./awsop-lab7.component.css']
})
export class AwsopLab7Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab7/awsop-lab7.component.ts